@if (plan_classes_unclassifieds && plan_classes_unclassifieds.length) {
<div class="w-100 my-2">
    <h2 class="column-header">
        PLAN TREATMENT - UNCLASSIFIED
    </h2>

    <table cdk-table [dataSource]="plan_classes_unclassifieds" multiTemplateDataRows class="table pagetable head-light">
        <ng-container cdkColumnDef="showCollapse">
            <th cdk-header-cell *cdkHeaderCellDef> </th>
            <td cdk-cell *cdkCellDef="let class" class="row-toggle">
                <i-bs [name]="iconNames.ChevronDown" [@openClose]="isExpanded[class.class_id] ? 'open' : 'closed'" class="d-inline-block"></i-bs>
            </td>
        </ng-container>
        <ng-container cdkColumnDef="class_name">
            <th cdk-header-cell *cdkHeaderCellDef> Class Name </th>
            <td cdk-cell *cdkCellDef="let class" [class.font-weight-bold]="showMatches && class.matched" [class.line-through]="showMatches && !class.matched">
                {{ class.class_name }}
            </td>
        </ng-container>
        <ng-container cdkColumnDef="allowed_claims">
            <th cdk-header-cell *cdkHeaderCellDef class="text-end"> Allowed Claims </th>
            <td cdk-cell *cdkCellDef="let class" class="text-end">
                <ng-container *ngTemplateOutlet="exact_min_max_currency; context: {exact: class.allowed_claims_exact, min: class.allowed_claims_min, max: class.allowed_claims_max}"></ng-container>
            </td>
        </ng-container>
        <ng-container cdkColumnDef="estimated_recovery">
            <th cdk-header-cell *cdkHeaderCellDef class="text-end"> Recovery</th>
            <td cdk-cell *cdkCellDef="let class" class="text-end">
                <ng-container *ngTemplateOutlet="exact_min_max_percentage; context: {exact: class.estimated_recovery_exact, min: class.estimated_recovery_min, max: class.estimated_recovery_max}"></ng-container>
            </td>
        </ng-container>
        <ng-container cdkColumnDef="expandedDetail">
            <td cdk-cell *cdkCellDef="let class" class="border-left border-right border-bottom rounded-bottom" [attr.colspan]="20">
                @if (isExpanded[class.class_id]) {
<div class="pt-2 pb-2" @expandCollapse>
                    <div class="row collapsible">
                        <h1>{{ class.toggle }}</h1>
                        <ng-container *ngTemplateOutlet="claims_table; context: {$implicit: class}"></ng-container>
                        <ng-container *ngTemplateOutlet="treatments_table; context: {$implicit: class}"></ng-container>
                    </div>
                </div>
}
            </td>
        </ng-container>
        <tr cdk-header-row *cdkHeaderRowDef="getNonEmptyColumns(plan_classes_unclassifieds, ['showCollapse'], ['showCollapse', 'class_name', 'allowed_claims', 'estimated_recovery'])"></tr>
        <tr cdk-row *cdkRowDef="let class; columns: getNonEmptyColumns(plan_classes_unclassifieds, ['showCollapse'], ['showCollapse', 'class_name', 'allowed_claims', 'estimated_recovery']);"
            (click)="isExpanded[class.class_id] = ! isExpanded[class.class_id]" class="clickable"
        >
        </tr>
        <!-- Extra row to show detail content column -->
        <tr cdk-row *cdkRowDef="let class; columns: ['expandedDetail']" [class.d-none]="! isExpanded[class.class_id]">
        </tr>
    </table>
</div>
}


<ng-template #exact_min_max_currency let-exact="exact" let-min="min" let-max="max">
    @if ((exact + min + max).trim().length === 0) {

        N/A

} @else {

        @if (exact.length > 0) {

            {{ exact | currency }}

} @else {

        @if (min.length > 0 && max.length > 0) {

            {{ min | currency }} - {{ max | currency }}

} @else {

        @if (min.length > 0) {

            &gt;{{ min | currency }}
} @else {

        @if (max.length > 0) {

            &lt;{{ max | currency }}

}

}

}

}

}
                </ng-template>
<ng-template #exact_min_max_percentage let-exact="exact" let-min="min" let-max="max">
    @if ((exact + min + max).trim().length === 0) {

        N/A

} @else {

        @if (exact.length > 0) {

            {{ exact }}%

} @else {

        @if (min.length > 0 && max.length > 0) {

            {{ min }} - {{ max }}%

} @else {

        @if (min.length > 0) {

            &gt;{{ min }}%

} @else {

        @if (max > 0) {

            &lt;{{ max }}%

}

}

}

}

}
                </ng-template>

<ng-template #treatments_table let-class>
    @if (class.toggle_treatments.length && treatmentColumnVisibility[class.class_id]) {
<div class="col-12 my-2">
        <h2 class="column-header">
            TREATMENTS
        </h2>
        <table class="table definitions">
            <thead>
                <tr>
                    <th class="pr-1 border-top-0">Claim/Interest</th>
                    <th class="text-center px-1 text-nowrap border-top-0">Option #</th>
                    @if (treatmentColumnVisibility[class.class_id]?.treatment_gift) {
<th class="text-center px-1 border-top-0">Recovery&nbsp;Consideration</th>
}
                    @if (treatmentColumnVisibility[class.class_id]?.linked_instrument_id) {
<th class="px-1 border-top-0">Post-petition Instrument</th>
}
                    @if (treatmentColumnVisibility[class.class_id]?.Other) {
<th class="px-1 border-top-0">CVRs/Trust Interest/Other Consideration!!</th>
}
                    @if (treatmentColumnVisibility[class.class_id]['received_dollar'] || treatmentColumnVisibility[class.class_id]['received_percent']) {
<th class="px-1 border-top-0 text-nowrap">%/$ Received</th>
}
                    @if (treatmentColumnVisibility[class.class_id]['notes'] || treatmentColumnVisibility[class.class_id]['recovery_amount_other']) {
<th class="pl-1 border-top-0">Notes</th>
}
                </tr>
            </thead>
            <tbody>
                @for (treatmentrow of class.toggle_treatments; track treatmentrow) {

                    @for (treatmentGroup of treatmentrow.groupedTreatments; track treatmentGroup; let claimIndex = $index) {

                        @for (treatment of treatmentGroup; track treatment; let treatmentIndex = $index) {

                            <tr>
                                @if (claimIndex == 0 && treatmentIndex == 0) {
<td class="pr-1" [attr.rowspan]="treatmentrow.count">{{ treatmentrow.treatment_name }}</td>
}
                                @if (treatmentIndex == 0) {
<td class="plain px-1 text-center" [attr.rowspan]="treatmentGroup.length">{{ treatment.option_number }}</td>
}
                                <td class="plain px-1 text-center">{{treatment?.treatment_gift}} </td>
                                @if (treatmentColumnVisibility[class.class_id]?.linked_instrument_id) {
<td class="px-1">
                                    <a href="/situations/{{situationID}}/profile/capital-structures/{{treatment.linked_instrument_id}}">{{instrumentIDLookup[treatment.linked_instrument_id]}}</a>
                                </td>
}
                                @if (treatmentColumnVisibility[class.class_id]?.Other) {
<td class="px-1" [innerHTML]="treatment.Other">
                                </td>
}
                                @if (treatmentColumnVisibility[class.class_id]['received_dollar'] || treatmentColumnVisibility[class.class_id]['received_percent']) {
<td class="px-1">
                                    @if (treatment.received_dollar > 0) {
{{treatment.received_dollar | currency}}
}
                                    @if (treatment.received_percent > 0) {
{{treatment.received_percent}}%
}
                                </td>
}
                                @if (treatmentColumnVisibility[class.class_id]['notes'] || treatmentColumnVisibility[class.class_id]['recovery_amount_other']) {
<td class="ps-2" [innerHTML]="treatment.notes"></td>
}
                            </tr>

}

}

}
            </tbody>
        </table>
    </div>
}
</ng-template>
<ng-template #claims_table let-class>
    @if (class.allowed_claims_individual.length) {
<div class="col-12 my-2">
        <table cdk-table [dataSource]="class.allowed_claims_individual" class="table table-borderless definitions w-100" recycleRows>
            <ng-container cdkColumnDef="claim_type">
                <th cdk-header-cell *cdkHeaderCellDef> Claim type </th>
                <td cdk-cell *cdkCellDef="let claim" class="plain">
                    {{claim.claim_type}}
                </td>
            </ng-container>
            <ng-container cdkColumnDef="instruments_dips">
                <th cdk-header-cell *cdkHeaderCellDef>Pre-petition Instruments </th>
                <td cdk-cell *cdkCellDef="let claim" class="pr-2">
                    <ul class="list-unstyled">
                        @for (id of claim.instruments_dips; track id) {
  <li>
                            <a (click)="openInstrument($event, situationID, id)">{{ instrumentIDLookup[id] }}</a>
                        </li>
}
                    </ul>
                </td>
            </ng-container>
            <ng-container cdkColumnDef="allowed_claims">
                <th cdk-header-cell *cdkHeaderCellDef> Allowed Claims </th>
                <td cdk-cell *cdkCellDef="let party" class="pr-2">
                    <ng-container *ngTemplateOutlet="exact_min_max_currency; context: {exact: class.allowed_claims_exact, min: class.allowed_claims_min, max: class.allowed_claims_max}"></ng-container>
                </td>
            </ng-container>
            <tr cdk-header-row *cdkHeaderRowDef="getNonEmptyColumns(class.allowed_claims_individual)"></tr>
            <tr cdk-row *cdkRowDef="let myRowData; columns: getNonEmptyColumns(class.allowed_claims_individual)"></tr>
        </table>
    </div>
}
</ng-template>
